<template>
  <div class="flex items-center">
    <!-- Cuando el plan está activo -->
    <template v-if="params.data.flag_active_plan_added_service !== 0">
      <div class="w-3/4">
        <vs-progress :percent="countAdvisorSteps(params.data.visaSteps)" :height="12" color="primary" class="w-full" v-if="params.data.visaSteps"></vs-progress>
      </div>
      <div class="w-1/4 ml-1">
        <p>{{value}}%</p>
      </div>
    </template>
    <!-- Cuando el plan está inactivo -->
    <template v-else>
      <p>Servicio desactivado</p>
    </template>
    
  </div>
</template>
<script>
export default {
  name: 'CellRendererLink',
  data () {
    return {
      value: null
    }
  },
  methods: {
    countAdvisorSteps (data) {
      if (data.length === 0) return 
      const advisorStepsArray = data.filter(item => item.number_advisor_visa_step !== null)
      const advisorStepsLength = advisorStepsArray.length
      const advisorStepsArrayCompleted = advisorStepsArray.filter(item => item.status_visa_step === 'Completado').length
      this.value = Math.floor((advisorStepsArrayCompleted / advisorStepsLength) * 100)
      return this.value
    }
  }
}
</script>
